import styled from "styled-components";
import { IndicatedHeading1, OldHeading1, OldHeading2, OldHeading3, Slogan } from "./headings-to-deprecate-or-transfer";

var setAndGetStyles = function setAndGetStyles(_ref) {
  var heading = _ref.heading;
  return "\n  color: " + heading.color + ";\n  margin: 0 0 32px;\n";
}; // Confirmed with the Design Team: only h1s will have accent colours.


var Heading1 =
/*#__PURE__*/
styled.h1.attrs({
  id: "main-heading"
}).withConfig({
  displayName: "Heading1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  var accentColor = theme.heading.accentColor;
  return "\n      " + setAndGetStyles(theme) + "\n      " + (accentColor ? "\n            span {\n              color: " + accentColor + ";\n            }\n          " : "") + "\n    ";
});
var Heading2 =
/*#__PURE__*/
styled.h2.withConfig({
  displayName: "Heading2"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme;
  return setAndGetStyles(theme);
});
var Heading3 =
/*#__PURE__*/
styled.h3.withConfig({
  displayName: "Heading3"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme;
  return setAndGetStyles(theme);
});
var Heading4 =
/*#__PURE__*/
styled.h4.withConfig({
  displayName: "Heading4"
})(["", ""], function (_ref5) {
  var theme = _ref5.theme;
  return setAndGetStyles(theme);
});
export { Heading1, Heading2, Heading3, Heading4, IndicatedHeading1, OldHeading1, OldHeading2, OldHeading3, Slogan };